import actions from './fileservice/actions'

export default {
    actions
}
